{
  "header": "Detalhes do ativo",
  "subtitle": "O ativo conectado ao seu caminhão (reboque, contêiner, etc).",
  "assetType": "Tipo de ativo",
  "assetTypePlaceholder": "Selecione o tipo de ativo",
  "assetId": "Número da placa",
  "assetIdPlaceholder": "Ex.: número do reboque, ID do contêiner, etc",
  "remove": "Remover",
  "addAnother": "Adicionar outro ativo",
  "trailerType": "Tipo de reboque",
  "trailerId": "ID do reboque"
}
